import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import type {
  EventResendWebhook,
  FailedEvent,
  FailedEventsQuery,
  ResendRequest,
  ResendResult,
} from '../../interfaces';
import { EventResendMockService } from './event-resend-mock.service';

/**
 * Data source of the event resend tool. The UI depends only on this contract, so the mock can be
 * replaced by the HTTP implementation by changing the provider below.
 */
@Injectable({
  providedIn: 'root',
  // TODO(TTLS-xxx): replace the mock with the real dispatch client when the backend endpoint exists.
  useFactory: (): EventResendGateway => inject(EventResendMockService),
})
export abstract class EventResendGateway {
  /** True while the data is fabricated, so the UI can say so. */
  abstract readonly isMock: boolean;

  /** Webhooks configured for the client in the given environment. */
  abstract listWebhooks(query: FailedEventsQuery): Observable<EventResendWebhook[]>;

  /** Failed events of the client, newest first. */
  abstract listFailedEvents(query: FailedEventsQuery): Observable<FailedEvent[]>;

  /** Dispatches the given events again through the normal dispatch flow. */
  abstract resendEvents(request: ResendRequest): Observable<ResendResult>;
}
